import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsPerformanceWorkflowStatusProjectLimitRoute: InvariantJiraRoute = {
	name: 'global-settings-performance-workflow-status-project-limit',
	path: '/jira/settings/system/performance/metrics/workflowStatus/projectlimit',
};
